export class RoutesConstants {
  static SIGN_IN_URL = 'sign-in';
  static PROJECTS_URL = 'projects';
  static TIMESHEETS_URL = 'timesheets';
  static UNAUTHORIZED_URL = 'unauthorized-account';
  static ZOHO_BOOKS_URL = 'zoho-books';
  static ZOHO_CALLBACK_URL = 'auth/zoho/callback';
  static ZOHO_SETUP_URL = 'zoho-setup';
  static BC_SYNC_URL = 'bc-sync';
  static REPORTING_URL = 'reporting';
}
